import { ProviderType } from '../../../enums/product';
import { getCMSConfig } from '../../../util/cms';

export const isProviderAvailable = (currentProvider: ProviderType, availableMetacodes: string[]): boolean => {
    const tariffsOfProvider = getCMSConfig()?.tariffIds?.[currentProvider];

    if (!tariffsOfProvider) {
        return false;
    }

    const metacodesOfProvider = Object.values(tariffsOfProvider);

    // Note: Has the two arrays at least one common element?
    return availableMetacodes.some(metacode =>
        metacodesOfProvider.includes(metacode)
    );
};

export const getAvailableProvider = (
    unavailableProvider: ProviderType,
    availableMetacodes: string[]
): ProviderType | undefined => {
    const tariffs = getCMSConfig()?.tariffIds;

    if (!tariffs) {
        return undefined;
    }

    let availableProvider: ProviderType[] = [];

    // Note: Search for provider(s), who has at least one available product
    Object.keys(tariffs).forEach(provider => {
        if (provider === unavailableProvider) {
            return;
        }

        let containsAtLeastOne: boolean = false;

        Object.values(tariffs[provider as ProviderType]).forEach(metacode => {
            if (availableMetacodes.includes(metacode)) {
                containsAtLeastOne = true;

                return;
            }
        });

        if (containsAtLeastOne) {
            availableProvider.push(provider as ProviderType);
        }
    });

    if (!availableProvider.length) {
        return undefined;
    }

    return availableProvider[0];
};

export const getNewSelectedMetacode = (
    oldProvider: ProviderType,
    oldSelectedMetacode: string | undefined,
    newProvider: ProviderType
): string | undefined => {
    const tariffs = getCMSConfig()?.tariffIds;

    if (!tariffs || !oldSelectedMetacode) {
        return undefined;
    }

    const index: number = Object.values(tariffs[oldProvider]).indexOf(oldSelectedMetacode);

    if (0 > index || index > Object.values(tariffs[newProvider]).length) {
        return undefined;
    }

    return tariffs[newProvider][index];
};
